import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class RolesQueryService {
    public GET_SPECIFIC_ID_BY_ROLE: any;
    public GET_ALL_ROLES: any;
    public GET_ALL_ROLES_AUDIT : any;

    constructor(public apollo: Apollo) {
        //get all roles 
        this.GET_SPECIFIC_ID_BY_ROLE = gql` 
            query GetReturnSelectedRole($roleName:String!) {
                allRoles(condition:{roleName:$roleName}) {
                    edges {
                        node {
                        roleName 
                        roleId
                        nodeId                        
                        usersByRoleId {
                            edges {
                            node {
                                firstName
                                lastName
                                email
                                password
                                createdAt
                                roleId
                                userId
                            }
                            }
                        }
                        }
                    }
                    }
            }
     `
            ;

        this.GET_ALL_ROLES = gql`
        query allRoles{
            allRoles(filter: {isDeletedYn: {equalTo: false}, roleDiv: {equalTo: true}}) {
              nodes {
                roleId
                roleDiv
                roleName
                roleDescription
                isDeletedYn
              }
              totalCount
            }
          }`;

        this.GET_ALL_ROLES_AUDIT = gql`
        query allRoles {
            allRoles(filter: {roleDiv: {equalTo: true}}) {
              nodes {
                roleId
                roleDiv
                roleName
                roleDescription
                isDeletedYn
              }
              totalCount
            }
          }`;

    };

    GET_ROLE_ID_BY_ROLE_NAME(roleName) {
        return this.apollo.watchQuery({
            query: this.GET_SPECIFIC_ID_BY_ROLE,
            variables:
            {
                roleName: roleName,
            },
            fetchPolicy: 'network-only'
        })
    }

    // GET all roles
    GET_ROLES(payload) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_ROLES,
            variables: payload,
            fetchPolicy: 'network-only'
        })
    }

    GET_ROLES_AUDIT(payload) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_ROLES_AUDIT,
            variables: payload,
            fetchPolicy: 'network-only'
        })
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/roles.ts